import { render, staticRenderFns } from "./IconGift.vue?vue&type=template&id=2fdfb4f7&"
import script from "./IconGift.vue?vue&type=script&lang=js&"
export * from "./IconGift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports